import { ChildModel, ModelBase } from 'store/model-base';

import { DiscountPromotion } from './discount-promotion';

export class DiscountPromoCollection extends ModelBase {
    public static storeName: string = 'discountPromoCollection';

    public mvnoPromotions: DiscountPromotion[];
    public isServiceLinePromo: boolean;
    public isServiceAccountPromo: boolean;
    public isPromoStateEligible: boolean;
    public isLinePromoEligible: boolean;
    public isLinePromoBYOEligible: boolean;
    public isAccountPromoUNLBOGOEligible: boolean;
    public isLinePromoUNLFREEEligible: boolean;
    public isLinePromoUNLHL25Eligible: boolean;
    public isAccountPromoEligible: boolean;
    public isTradeInDDAPromoEligible: boolean;
    public isExtendedPromoDollarEligible: boolean;
    public linePromotion: DiscountPromotion;
    public accountPromotion: DiscountPromotion;
    public linePromoBYOEligible: DiscountPromotion[];
    public linePromoUNLEligible: DiscountPromotion[];
    public linePromoUNLHL25Eligible: DiscountPromotion[];
    public accountPromoEligible: DiscountPromotion[];
    public tradeInDDAPromoEligible: DiscountPromotion[];
    public extendedPromoDollarEligible: DiscountPromotion[];
    public isPlans8PromoEligible: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: DiscountPromoCollection = super.create<DiscountPromoCollection>(initData);

        toReturn.linePromotion = toReturn.mvnoPromotions.find((promo: DiscountPromotion) => promo.isServiceLinePromo);
        toReturn.accountPromotion = toReturn.mvnoPromotions.find((promo: DiscountPromotion) => promo.isServiceAccountPromo);

        toReturn.accountPromoEligible = toReturn.mvnoPromotions.filter((promo: DiscountPromotion) => promo.isAccountPromoEligible);
        toReturn.linePromoBYOEligible = toReturn.mvnoPromotions.filter((promo: DiscountPromotion) => promo.isLinePromoBYOEligible);
        toReturn.linePromoUNLEligible = toReturn.mvnoPromotions.filter((promo: DiscountPromotion) => promo.isLinePromoUNLFREEEligible);
        toReturn.linePromoUNLHL25Eligible = toReturn.mvnoPromotions.filter((promo: DiscountPromotion) => promo.isLinePromoUNLHL25Eligible);
        toReturn.tradeInDDAPromoEligible = toReturn.mvnoPromotions.filter((promo: DiscountPromotion) => promo.isTradeInDDAPromoEligible);
        toReturn.extendedPromoDollarEligible = toReturn.mvnoPromotions.filter((promo: DiscountPromotion) => promo.isExtendedPromoDollarEligible);

        toReturn.isServiceLinePromo = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isServiceLinePromo);
        toReturn.isServiceAccountPromo = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isServiceAccountPromo);
        toReturn.isPromoStateEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isPromoStateEligible);
        toReturn.isLinePromoEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isLinePromoEligible);
        toReturn.isAccountPromoEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isAccountPromoEligible);
        toReturn.isLinePromoBYOEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isLinePromoBYOEligible);
        toReturn.isAccountPromoUNLBOGOEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isAccountPromoUNLBOGOEligible);
        toReturn.isLinePromoUNLFREEEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isLinePromoUNLFREEEligible);
        toReturn.isLinePromoUNLHL25Eligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isLinePromoUNLHL25Eligible);
        toReturn.isTradeInDDAPromoEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isTradeInDDAPromoEligible);
        toReturn.isExtendedPromoDollarEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isExtendedPromoDollarEligible);
        toReturn.isPlans8PromoEligible = toReturn.mvnoPromotions.some((promo: DiscountPromotion) => promo.isLinePromoUNLFREEEligible || promo.isLinePromoUNLHL25Eligible || promo.isPlans8FreeLinePromo 
        || promo.isPlans8UnlFreeLinePromo || promo.isPlans8UnlFreeLineAnytimePromo);


        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T><any>toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'mvnoPromotions',
            model: DiscountPromotion
        }];
    }
}
